module.exports = __webpack_public_path__ + "img/image14.cacb53e5.png";